import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProtectWhatYouLove = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "protectWhatYouLove",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12633",
			"data-name": "Path 12633",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12634",
			"data-name": "Path 12634",
			d: "M20,11.242a10.345,10.345,0,0,1-7.48,9.686,1.914,1.914,0,0,1-1.04,0A10.344,10.344,0,0,1,4,11.242V7.214A2,2,0,0,1,5.243,5.363l4.864-1.99a5,5,0,0,1,3.787,0l4.864,1.99A2,2,0,0,1,20,7.214Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12640",
			"data-name": "Path 12640",
			d: "M12,13.535A1.625,1.625,0,0,1,13.232,13,1.81,1.81,0,0,1,15,14.8c0,1.813-2.407,3.2-3,3.2s-3-1.389-3-3.2A1.81,1.81,0,0,1,10.768,13,1.625,1.625,0,0,1,12,13.535Z",
			transform: "translate(0 -3)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgProtectWhatYouLove;
